export default __webpack_public_path__ + "static/media/attendance-grey.fd71656c.svg";